export default __webpack_public_path__ + "assets/images/9b88342f4bb5fa65e2e6232944c1bce9.png";